module.exports = __webpack_public_path__ + "img/lifepak-20.189fde6f.png";